module.exports = __webpack_public_path__ + "static/img/ltt.7e48271.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myteam/ltt.png
// module id = dONP
// module chunks = 1